module.exports = __webpack_public_path__ + "img/sage-2.d648c40b.jpg";